import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from './BootScene';

export class Preloader extends Phaser.Scene {
  constructor() {
    super({ key: 'Preloader' });
  }

  create(): void {
    const width = GAME_WIDTH;
    const height = GAME_HEIGHT;

    // Beautiful loading screen
    const bg = this.add.rectangle(width / 2, height / 2, width, height, 0x1a1a2e);

    // Title banner
    const bannerBg = this.add.rectangle(width / 2, 80, 600, 80, 0xDEB887)
      .setStrokeStyle(4, 0x8B5A2B);
    
    const title = this.add.text(width / 2, 80, 'POCKET MUSTANG PRESERVE', {
      fontFamily: 'Courier New',
      fontSize: '32px',
      fontStyle: 'bold',
      color: '#2F4F4F'
    }).setOrigin(0.5);

    // Horse emoji animation
    const horseEmoji = this.add.text(width / 2, height / 2 - 40, '🐴', {
      fontSize: '64px'
    }).setOrigin(0.5);

    // Bounce animation
    this.tweens.add({
      targets: horseEmoji,
      y: height / 2 - 60,
      duration: 500,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut'
    });

    // Loading text
    const loadingText = this.add.text(width / 2, height / 2 + 40, 'Saddling up...', {
      fontFamily: 'Courier New',
      fontSize: '20px',
      fontStyle: 'italic',
      color: '#DEB887'
    }).setOrigin(0.5);

    // Progress bar background
    const progressBox = this.add.rectangle(width / 2, height / 2 + 100, 320, 30, 0x2F4F4F)
      .setStrokeStyle(2, 0xDEB887);

    const progressBar = this.add.rectangle(width / 2 - 155, height / 2 + 100, 0, 24, 0x90EE90)
      .setOrigin(0, 0.5);

    // Simulate loading with smooth progress
    let progress = 0;
    const loadingMessages = [
      'Saddling up...',
      'Counting horses...',
      'Checking water sources...',
      'Surveying the range...',
      'Ready to ride!'
    ];

    this.time.addEvent({
      delay: 100,
      repeat: 20,
      callback: () => {
        progress += 0.05;
        progressBar.width = 310 * Math.min(progress, 1);
        
        const msgIndex = Math.floor(progress * (loadingMessages.length - 1));
        loadingText.setText(loadingMessages[Math.min(msgIndex, loadingMessages.length - 1)]);

        if (progress >= 1) {
          this.time.delayedCall(300, () => {
            this.cameras.main.fadeOut(500, 0, 0, 0);
            this.cameras.main.once('camerafadeoutcomplete', () => {
              this.scene.start('GameScene');
            });
          });
        }
      }
    });

    // Version text
    this.add.text(width - 10, height - 10, 'v3.0', {
      fontFamily: 'Courier New',
      fontSize: '12px',
      color: '#666666'
    }).setOrigin(1, 1);
  }
}
